// extracted by mini-css-extract-plugin
var _1 = "Dialog-module_dialog_body__ps0GPZ";
var _2 = "Dialog-module_dialog_close__L3_T7G";
var _3 = "Dialog-module_dialog_header__GBYP2y";
var _4 = "Dialog-module_dialog_title__hOlQVs";
var _5 = "Dialog-module_modal_container__QBDDww";
var _6 = "Dialog-module_modal_dialog__Y5EtO6";
export { _1 as "dialog_body", _2 as "dialog_close", _3 as "dialog_header", _4 as "dialog_title", _5 as "modal_container", _6 as "modal_dialog" }
